import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { app } from "../firebase-config.js";

const storage = getStorage(app);

/**
 * Uploads an image blob to Firebase Storage.
 * @param {Blob} blob - The image blob to upload.
 * @param {string} path - The storage path (e.g., 'users/uid/profile.webp').
 * @returns {Promise<string>} - A promise that resolves with the download URL.
 */
export const uploadImage = async (blob, path) => {
    try {
        const storageRef = ref(storage, path);
        const task = uploadBytesResumable(storageRef, blob, { contentType: 'image/webp' });
        await task;
        return await getDownloadURL(storageRef);
    } catch (error) {
        console.error("Image upload failed:", error);
        throw error;
    }
};
